var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"zoomer",style:(_vm.zoomerStyle)},[_c('div',{staticClass:"position",style:(_vm.positionStyle)},[(_vm.$slots.default)?_c('div',{staticClass:"custom-zoomer",style:(_vm.zoomedStyle)},[_vm._t("default")],2):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }